import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import Select from '@stories/Components/Inputs/Select/Select';
import styled from 'styled-components';
const Container = styled.div `
  ${transition('opacity')};
  border-top: 2px solid ${brand.lightGrey};
  padding-top: 22px;

  @media ${from(Device.TabletLarge)} {
    padding-top: 30px;
  }
`;
const FormLabel = styled.h2 `
  ${headingStyles}
  font-size: 20px;
`;
const SelectBox = styled(Select) `
  border:0;  
  padding: 0;
  height: 33px;
  background-position: right;

  &[data-theme='light'] {
    --bgColor: ${brand.grey};
  }
`;
const BedroomTabStyles = {
    Container,
    FormLabel,
    SelectBox,
};
export default BedroomTabStyles;
